// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".background[data-v-2e606f7c]{background-color:rgba(0,0,0,.5)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
